export type ConsentStatus = 'granted' | 'denied' | null;

const STORAGE_KEY = 'cookie_consent';

type ConsentListener = (status: ConsentStatus) => void;
const listeners: ConsentListener[] = [];

export const getConsent = (): ConsentStatus => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch {
    return null;
  }
};

export const setConsent = (status: 'granted' | 'denied'): void => {
  try {
    localStorage.setItem(STORAGE_KEY, status);
  } catch {
    // storage non disponibile: il consenso vale solo per la sessione corrente
  }
  listeners.forEach((cb) => cb(status));
};

export const onConsentChange = (cb: ConsentListener): void => {
  listeners.push(cb);
};
